import Foundation from "foundation-sites";
import lozad from "lozad";

function bannerColor() {
  if ($(".content").length) {
    setTimeout(() => {
      var distance = $(".content").offset().top;
      distance = distance - $(".header").height();

      $(window).scroll(function () {
        if ($(window).scrollTop() >= distance) {
          $(".header").css({
            background: "#383737",
          });
        } else {
          $(".header").css({
            background: "transparent",
          });
        }
      });
    }, 1500);
  }
}

// ---------------------------------------------------------------------
// Normal Form "controller"
// ---------------------------------------------------------------------
function validate(form) {
  let hasErrors = false;
  form.querySelectorAll("input, textarea").forEach((el) => {
    const errorMsg = el.closest("div").querySelector("p.error");
    if (!el.validity.valid) {
      if (errorMsg) errorMsg.innerHTML = el.validationMessage;
      el.setAttribute("aria-invalid", "true");
      hasErrors = true;
    } else if (errorMsg) {
      el.setAttribute("aria-invalid", "false");
      errorMsg.innerHTML = "";
    }
  });
  return !hasErrors;
}

function handleSubmit(e) {
  console.log("here");
  e.preventDefault();
  const form = e.target.closest("form");
  const response = form.querySelector(".form-response");
  if (validate(form)) {
    fetch(form.action, { method: "POST", body: new FormData(form) })
      .then((res) => {
        if (!res.ok)
          throw new Error("Basin did not return a 200 level status code.");
        if (response)
          response.innerText =
            "Thank you for submitting our form! Someone from our office will be in touch shortly.";
        form.reset();
      })
      .catch((error) => {
        console.error("Error submitting form ", error);
        if (response)
          response.innerText =
            "There was an error submitting your form. Please try again, or contact us directly via telephone.";
      });
  }
}

export default {
  init() {
    const observer = lozad();
    observer.observe();

    let menu = $("#menu-main-menu");

    new Foundation.AccordionMenu(menu, {
      submenuToggle: true,
    });

    console.log("hi");
    const formButton = document.getElementById("form-submit");
    if (formButton) formButton.addEventListener("click", handleSubmit);
  },
  finalize() {
    $(".header__right-button").click(function () {
      $(".header").toggleClass("fixed");

      $(".header__right-nav").toggleClass("hidden");

      let text = $(".header__right-button-text").text();
      $(".header__right-button-text").text(text == "Menu" ? "Close" : "Menu");
    });

    if (window.matchMedia("(min-width: 1024px)").matches) {
      bannerColor();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js